module.exports = __webpack_public_path__ + "img/Z61Q_18.bd8751bc.jpg";